import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthGuardData, createAuthGuard } from 'keycloak-angular'

const isBackofficeAllowed = async (_route: unknown, state: { url: string }, authData: AuthGuardData): Promise<boolean | ReturnType<Router['parseUrl']>> => {
  const { authenticated, keycloak, grantedRoles } = authData

  if (!authenticated) {
    await keycloak.login({ redirectUri: window.location.origin + state.url })
    return false
  }

  const availableRoles = grantedRoles.resourceRoles[keycloak.clientId!]
  if (!availableRoles || availableRoles.length === 0) {
    return inject(Router).parseUrl('/not-authorized')
  }

  return true
}

export const canActivateBackoffice: CanActivateFn = createAuthGuard<CanActivateFn>(isBackofficeAllowed)
